import CryptoJS from "crypto-js";

const secretKey = process.env.NEXT_PUBLIC_ENCRYPT_KEY;

const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const setEncryptedItem = (key, data) => {
  const encryptedData = encryptData(data);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(key, encryptedData);
  }
};

export const getDecryptedItem = (key) => {
  if (typeof window !== "undefined") {
    const encryptedData = window.localStorage.getItem(key);
    if (encryptedData) {
      return decryptData(encryptedData);
    }
  }
  return null;
};
